// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `


.intl-tel-input input {
    height: 5.7rem;
    border-radius:2.5rem;
    width: 100%;
    border : 0.4rem solid #EDEDED; 
    font-size:1.8rem ;
  }
.intl-tel-input {
width: 100%;
}

.intl-tel-input input:focus {
    border : 0.4rem solid #009FE3; 
    
}`, "",{"version":3,"sources":["webpack://./src/components/WePhoneInput/styles.css"],"names":[],"mappings":";;;AAGA;IACI,cAAc;IACd,oBAAoB;IACpB,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;EACnB;AACF;AACA,WAAW;AACX;;AAEA;IACI,6BAA6B;;AAEjC","sourcesContent":["\n\n\n.intl-tel-input input {\n    height: 5.7rem;\n    border-radius:2.5rem;\n    width: 100%;\n    border : 0.4rem solid #EDEDED; \n    font-size:1.8rem ;\n  }\n.intl-tel-input {\nwidth: 100%;\n}\n\n.intl-tel-input input:focus {\n    border : 0.4rem solid #009FE3; \n    \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
